import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { MediaMatcher } from '@angular/cdk/layout';

@Component({
  selector: 'bt-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, OnDestroy {
  private _mobileQueryListener: () => void;
  mobileQuery: MediaQueryList;

  tempMenus = [
    {
      icon: 'home',
      title: 'داشبورد',
      link: '/',
      roles: [2, 3, 4],
      children: [],
    },
    {
      icon: 'person',
      title: 'پروفایل من',
      link: '/profile',
      roles: [2, 3, 4],
      children: [
        {
          link: '/profile/info',
          title: 'اطلاعات کلی'
        },
        {
          link: '/profile/more',
          title: 'اطلاعات تکمیلی'
        }
      ],
    },
    {
      icon: 'reorder',
      title: 'مدیریت آگهی',
      link: '/manage-posts',
      roles: [2, 3, 4],
      children: [
        {
          link: '/manage-posts/free',
          title: 'آگهی‌های رایگان'
        },
        {
          link: '/manage-posts/pro',
          title: 'آگهی‌های ویژه'
        },
        {
          link: '/manage-posts/expire',
          title: 'آگهی‌های منقضی شده'
        }
      ],
    },
    {
      icon: 'attachment',
      title: 'قراردادها',
      link: '/contract',
      roles: [2, 3, 4],
      children: [],
    },
    {
      icon: 'card_giftcard',
      title: 'پورسانت و پاداش',
      link: '/reward',
      roles: [2, 3, 4],
      children: [],
    },
    {
      icon: 'line_style',
      title: 'زیر مجموعه',
      link: '/subset',
      roles: [3, 4],
      children: [],
    },
    {
      icon: 'attach_money',
      title: 'امور مالی',
      link: '/financial',
      roles: [2, 3, 4],
      children: [],
    },
    {
      icon: 'contact_support',
      title: 'پشتیبانی',
      link: '/support',
      roles: [2, 3, 4],
      children: [
        {
          title: 'تیکت‌ها',
          link: '/support/tickets',
        },
        {
          title: 'تماس با شرکت',
          link: '/support/contact',
        },
        {
          title: 'پیام‌های ادمین',
          link: '/support/admin-messages',
        },
      ],
    },
  ];

  menus = [];

  get fullName() {
    const fName = localStorage.getItem('name');
    const lName = localStorage.getItem('family');
    return fName + ' ' + lName;
  }

  get roleTitle() {
    return localStorage.getItem('roleID');
  }

  canSee(roles: number[]) {
    return this.authService.hasRole(roles);
  }

  constructor(
    media: MediaMatcher,
    changeDetectorRef: ChangeDetectorRef,
    private authService: AuthService,
  ) {
    this.mobileQuery = media.matchMedia('(max-width: 900px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit() {
    for (const item of this.tempMenus) {
      if (item.roles.find(x => +x === +localStorage.getItem('roleId'))) {
        this.menus.push(item);
      }
    }
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  onLogout() {
    this.authService.signOut();
  }
}
